module.exports = __webpack_public_path__ + "img/1998_S.3c479baf.png";